import { Component } from '@angular/core';
import { JeevesInvoiceCardListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'sjoborg-invoice-card-list',
    templateUrl: './sjoborg-invoice-card-list.component.html',
    standalone: false
})
export class SjoborgInvoiceCardListComponent extends JeevesInvoiceCardListComponent {}
